import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from '../../context/TranslationContext';

import {
  StyledContainer,
  StyledItem,
  StyledButton,
  MoveAreaBox,
  EyeContainer,
  EyeBox,
  Pupil,
} from './styles';
import { computeEyePositions, getRectById } from './helpers';

const NotFoundPage = () => {
  const [eyePosition, setEyePosition] = useState({
    leftEye: { x: 0, y: 0 },
    rightEye: { x: 0, y: 0 },
  });
  const navigate = useNavigate();
  const { translate } = useTranslation();

  const handleGoHome = () => {
    navigate('/');
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      const leftRect = getRectById('leftEye');
      const rightRect = getRectById('rightEye');
      if (!leftRect || !rightRect) return;

      const positions = computeEyePositions(
        leftRect,
        rightRect,
        event.clientX,
        event.clientY,
        8, // maxDistance
      );

      setEyePosition(positions);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <StyledContainer>
      <StyledItem>
        <Typography variant="h1">404</Typography>
      </StyledItem>
      <StyledItem>
        <Typography variant="h3">{translate('notFoundPage.notFound')}</Typography>
      </StyledItem>
      <StyledItem>
        <Typography variant="body1">{translate('notFoundPage.pageDoesNotExist')}</Typography>
      </StyledItem>
      <StyledButton variant="contained" color="primary" onClick={handleGoHome}>
        {translate('notFoundPage.backToHome')}
      </StyledButton>
      <MoveAreaBox>
        <EyeContainer>
          <EyeBox id="leftEye">
            <Pupil x={eyePosition.leftEye.x} y={eyePosition.leftEye.y} />
          </EyeBox>
          <EyeBox id="rightEye">
            <Pupil x={eyePosition.rightEye.x} y={eyePosition.rightEye.y} />
          </EyeBox>
        </EyeContainer>
      </MoveAreaBox>
    </StyledContainer>
  );
};

export default NotFoundPage;
